<template>
  <div>
    <div v-if="showRegionLink && showZoneLink" class="d-inline-block">
      <div :typeBtn="'clearBtn d-inline-block text-xs-right'">
        <div class="mr-2">
          <span class="black--text">המערכת איתרה עבורך</span>
          <span class="primary--text">{{ zoneSuggestion[0].JobCount.toLocaleString() }}</span>
          <span class="black--text">משרות נוספות באזור</span>
          <nuxt-link :to="`/jobs/area/${regionLink}`">
            <span class="primary--text">{{ regionSuggestion[0].Item.NameInHebrew }}</span>
          </nuxt-link>
        </div>
      </div>

      <div :typeBtn="'clearBtn d-inline-block text-xs-right'">
        <div class="mr-2">
          <span class="black--text">האם יעניין אותך להרחיב את החיפוש לאזור</span>
          <nuxt-link :to="`/jobs/area/${zoneLink}`">
            <span class="primary--text">{{ zoneSuggestion[0].Item.NameInHebrew }}</span>
          </nuxt-link>
        </div>
      </div>
    </div>

    <div v-else-if="showZoneLink && !showRegionLink">
      <div :typeBtn="'clearBtn text-xs-right'">
        <div class="mr-2">
          <span class="black--text">המערכת איתרה עבורך</span>

          <span class="primary--text">{{ zoneSuggestion[0].JobCount.toLocaleString() }}</span>
          משרות נוספות באזור
          <nuxt-link :to="`/jobs/area/${zoneLink}`">
            <span class="primary--text">{{ zoneSuggestion[0].Item.NameInHebrew }}</span>
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showRegionLink: {
      type: Boolean
    },

    showZoneLink: {
      type: Boolean
    },

    zoneSuggestion: {
      type: Object
    },

    regionSuggestion: {
      type: Object
    },

    regionLink: {
      type: Number
    },

    zoneLink: {
      type: String
    }
  }
}
</script>
